import { useEffect, useState } from "react";
import { ParentGetTeachers } from "services/Parent/ParentServices";
import ParentLoader from "./ParentLoader";
import ParentEmpty from "./ParentEmpty";
import { useAuth } from "context/AuthContext";

const ParentTeachersTab = ({studentId}) => {
    const { userInfo } = useAuth();
    const [data, setData] = useState(null);

    useEffect(() => {

        ParentGetTeachers(userInfo?.token, Number(studentId)).then(r => setData(r.teachers)).catch(() => setData([]));

    }, []);
    console.log(data)



    if (!data) return <ParentLoader />;

    if (data.length === 0) return <ParentEmpty msg="لا توجد بيانات عن طاقم التدريس حالياً" />;



    return (

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">

            {data.map((t, idx) => {

                const emp = t.employee;

                const name = emp ? `${emp.first_name} ${emp.middle_name || ''} ${emp.last_name || ''}`.trim() : 'معلم غير مسمى';

                const subject = t.subjects[0]?.name || 'مادة غير محددة';

                const gender = emp?.gender || 'male';

                // Fallback avatar based on gender

                const defaultAvatar = gender === 'female'

                    ? 'https://cdn-icons-png.flaticon.com/512/194/194935.png'

                    : 'https://cdn-icons-png.flaticon.com/512/194/194931.png';



                return (

                    <div key={t.id || idx} className="bg-white/80 dark:bg-white/5 backdrop-blur-md border border-gray-200 dark:border-white/10 rounded-3xl p-6 shadow-sm hover:shadow-xl hover:translate-y-[-4px] transition-all group flex flex-col items-center text-center">

                        <div className="relative mb-4">

                            <div className="w-24 h-24 rounded-2xl overflow-hidden border-4 border-blue-500/20 shadow-lg group-hover:border-blue-500/40 transition-colors">

                                <img

                                    src={emp?.image_path || defaultAvatar}

                                    alt={name}

                                    className="w-full h-full object-cover"

                                    onError={(e) => { e.target.src = defaultAvatar; }}

                                />

                            </div>

                            <div className="absolute -bottom-2 -right-2 bg-blue-600 text-white w-8 h-8 rounded-xl flex items-center justify-center shadow-md animate-bounce-slow">

                                <span className="text-xs">🎓</span>

                            </div>

                        </div>



                        <h4 className="text-lg font-black text-gray-900 dark:text-white mb-1 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors">{name}</h4>

                        <div className="bg-blue-500/10 dark:bg-blue-500/20 text-blue-700 dark:text-blue-300 px-4 py-1 rounded-full text-sm font-bold border border-blue-200 dark:border-blue-500/30 shadow-sm">

                            {subject}

                        </div>



                        <div className="mt-6 w-full pt-4 border-t border-gray-100 dark:border-white/5 flex justify-center gap-4">

                            <div className="text-xs font-bold text-gray-500 dark:text-gray-400 flex flex-col items-center">

                                <span className="text-lg mb-1">📝</span>

                                <span>تقارير</span>

                            </div>

                            <div className="text-xs font-bold text-gray-500 dark:text-gray-400 flex flex-col items-center">

                                <span className="text-lg mb-1">📅</span>

                                <span>حصص</span>

                            </div>

                        </div>

                    </div>

                );

            })}

            <style>{`

                @keyframes bounce-slow {

                    0%, 100% { transform: translateY(0); }

                    50% { transform: translateY(-5px); }

                }

                .animate-bounce-slow {

                    animation: bounce-slow 3s ease-in-out infinite;

                }

            `}</style>

        </div>

    );
}

export default ParentTeachersTab;